import React from "react";
import { useAuth } from "../../context/AuthContext";
import LoadingScreen from "../common/LoadingScreen";
import ErrorMessage from "../common/ErrorMessage";
import SuccessMessage from "../common/SuccessMessage";
import ActionButtonsSettings from "./ActionButtonsSettings";
import { useLayoutContext } from "../../context/LayoutContext";

const NotificationsSettings = () => {
  const {
    userSettings,
    setUserSettings,
    systemError,
    setSystemError,
    loading,
    setLoading,
    error,
    setError,
    success,
    setSuccess,
    modalScreen,
    setModalScreen,
    page,
    setPage,
  } = useLayoutContext();
  const { saveProfile } = useAuth();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    try {
      const updatedSettings = userSettings as ProfileAndSettings;
      if (!updatedSettings) {
        console.error("User settings not loaded");
        return;
      }

      console.log("Updated user settings:", updatedSettings);
      // Assuming you have an API endpoint to update the settings
      const returnUpdatedSettings = await saveProfile(updatedSettings);
      setUserSettings(returnUpdatedSettings);
      setSuccess("Configurações atualizadas com sucesso!");
    } catch (error) {
      console.warn("Error updating settings:", error);
      setError("Failed to update settings. Please try again later.");
    } finally {
      setLoading(null);
    }
  };

  if (!userSettings) {
    return <div>Loading...</div>;
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="box">
        <fieldset>
          <legend className="title is-4">
            Notificações sobre computadores
          </legend>
          <div className="form-group">
            <div className="control">
              <input
                type="checkbox"
                id="new-compounds"
                name="email-notifications"
                className="checkbox"
                checked={
                  userSettings?.notificationsSettings
                    ?.added_compounds_enabled ?? false
                }
                onChange={(e) => {
                  const updatedSettings = {
                    ...userSettings,
                    notificationsSettings: {
                      ...userSettings.notificationsSettings,
                      added_compounds_enabled: e.target.checked,
                    },
                  };
                  setUserSettings(updatedSettings as ProfileAndSettings);
                }}
              />
              <label htmlFor="new-compounds" className="ml-2">
                Receber notificações sobre novos computadores.
              </label>
            </div>
          </div>
          <div className="form-group">
            <div className="control">
              <input
                type="checkbox"
                id="update-compounds"
                name="update-compounds"
                className="checkbox"
                checked={
                  userSettings?.notificationsSettings
                    ?.updated_compounds_enabled ?? false
                }
                onChange={(e) => {
                  const updatedSettings = {
                    ...userSettings,
                    notificationsSettings: {
                      ...userSettings.notificationsSettings,
                      updated_compounds_enabled: e.target.checked,
                    },
                  };
                  setUserSettings(updatedSettings as ProfileAndSettings);
                }}
              />
              <label htmlFor="update-compounds" className="ml-2">
                Receber notificações sobre actualização de computadores.
              </label>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="box">
        <fieldset>
          <legend className="title is-4">Notificações Propostas</legend>
          <div className="form-group">
            <div className="control">
              <input
                type="checkbox"
                id="offer-reminders"
                name="offer-reminders"
                className="checkbox"
                checked={
                  userSettings?.notificationsSettings?.pending_offers_enabled ??
                  false
                }
                onChange={(e) => {
                  const updatedSettings = {
                    ...userSettings,
                    notificationsSettings: {
                      ...userSettings.notificationsSettings,
                      pending_offers_enabled: e.target.checked,
                    },
                  };
                  setUserSettings(updatedSettings as ProfileAndSettings);
                }}
              />
              <label htmlFor="offer-reminders" className="ml-2">
                Receba lembretes para propostas pendentes diariamente.
              </label>
            </div>
          </div>
          <div className="form-group">
            <div className="control">
              <input
                type="checkbox"
                id="offer-expiration"
                name="offer-expiration"
                className="checkbox"
                checked={
                  userSettings?.notificationsSettings
                    ?.expiring_offers_enabled ?? false
                }
                onChange={(e) => {
                  const updatedSettings = {
                    ...userSettings,
                    notificationsSettings: {
                      ...userSettings.notificationsSettings,
                      expiring_offers_enabled: e.target.checked,
                    },
                  };
                  setUserSettings(updatedSettings as ProfileAndSettings);
                }}
              />
              <label htmlFor="offer-expiration" className="ml-2">
                Receba notificações quando uma proposta estiver prestes a
                expirar (2 dias antes do dia de expiração).
              </label>
            </div>
            <div className="form-group">
              <div className="control">
                <input
                  type="checkbox"
                  id="offer-notifications"
                  name="offer-notifications"
                  className="checkbox"
                  checked={
                    userSettings?.notificationsSettings?.new_orders_enabled ??
                    false
                  }
                  onChange={(e) => {
                    const updatedSettings = {
                      ...userSettings,
                      notificationsSettings: {
                        ...userSettings.notificationsSettings,
                        new_orders_enabled: e.target.checked,
                      },
                    };
                    setUserSettings(updatedSettings as ProfileAndSettings);
                  }}
                />
                <label htmlFor="offer-notifications" className="ml-2">
                  Receba notificações por e-mail sobre o estado das propostas
                  (aceites/rejeitadas).
                </label>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <ActionButtonsSettings />
    </form>
  );
};

export default NotificationsSettings;
